<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>ตรวจสอบใบจัดส่งสินค้า</v-container>
    <v-container fluid>
      <v-flex xs12 md4 offset-md4>
        <v-text-field
          ref="parcel"
          label="รหัส กล่อง/หีบบรรจุ, เอกสารอ้างอิง"
          :append-icon="parcel.Input ? 'send' : ''"
          outline
          single-line
          clearable
          v-model="parcel.Input"
          :error-messages="parcel.errorMessage"
          @click:append="parcelEnterScan"
          @keyup.enter="parcelEnterScan "
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 v-for="(parcel) in parcelResult" :key="parcel.parcel_guid">
            <v-card class="mt-3">
              <v-card-title>
                <v-icon large left>drafts</v-icon>
                <span
                  class="title font-weight-light"
                >{{ parcel.cust_name }} ({{ parcel.parcel_guid }})</span>
              </v-card-title>
              <v-card-text>{{ parcel.address }}</v-card-text>
              <v-card-actions>
                <div>{{ parcel.ref_doc_no }}</div>
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  icon
                  @click="printParcelById(parcel.parcel_guid)"
                >
                   <v-icon title="พิมพ์">print</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import PackShipService from "@/services/PackShipService";
import Utils from "@/util";

export default {
  name: "shipmentpacktrack",
  metaInfo: {
    title: "ตรวจสอบใบจัดส่งสินค้า"
  },
  components: {
    // VWidget,
    // MiniStatistic,
    // VCircle,
    // ProfileCard,
    // CircleStatistic,
    // LinearStatistic,
    // BoxChart
  },
  data: () => ({
    parcel: {
      Input: "",
      errorMessage: ""
    },
    foundParcel: false,
    custName: "",
    custAddress: "",
    parcelResult: {}
  }),
  computed: {},
  methods: {
    //...mapActions('app', ['setTitleText']),
    async parcelEnterScan() {
      // console.log(this.parcel.Input);
      if (!this.parcel.Input) return;

      await PackShipService.getParcel(this.parcel.Input)
        .then(res => {
          // console.log(res);

          if (res.success) {
            this.foundParcel = true;
            this.parcel.errorMessage = "";
            this.parcel.Input = "";
            //this.custName = res.parcels[0].cust_name;
            //this.custAddress = res.parcels[0].;
            this.parcelResult = res.parcels;
            // console.log(this.parcelResult);
          } else {
            this.foundParcel = false;
            this.parcel.errorMessage = res.message;
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    async printParcelById(id) {
      // console.log(id);

      await PackShipService.getParcel(id)
        .then(res => {
          // console.log(res);

          if (res.success) {
            this.printParcel(res.parcels[0]);
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    printParcel(parcel) {
      var pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {        
        var pdfFonts = require("@/print/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew-Bold.ttf",
          italics: "THSarabunNew-Italic.ttf",
          bolditalics: "THSarabunNew-BoldItalic.ttf"
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf"
        }
      };
      let docDefinition = {
        pageSize: {
          width: 280,
          height: 410
        },
        pageOrientation: 'landscape',
        pageMargins: [10, 10, 10, 45],
        footer: {
          text: "จาก OR 099-009-3588",
          margin: [70, 0, 28, 0],
          fontSize: 24,
          alignment: "right",
          style: ['boldStyle']
        },

        content: [
          {            
            columns: [
              {
                width: 130,
                text: "ส่ง",
                fontSize: 58,
                style: ['boldStyle']
              },
              {
                width: "*",
                text: `จำนวน ${parcel.parcel_no}/${parcel.parcel_all} `,
                fontSize: 30,
                alignment: "center",
                style: ['boldStyle']
              },
              // {
              //   width: 140,
              //   qr: parcel.parcel_guid,
              //   fit: "80",
              //   alignment: 'right'
              // },
              {
                width: 140,
                qr: parcel.parcel_guid,
                fit: "60",
                alignment: 'right',
                margin: [0, 20, 0, 0],
              },
            ]
          },
          {
            text: Utils.thaiCharCutStr(parcel.cust_name, 25), //parcel.cust_name.substring(0, 25),
            noWrap: true,
            alignment: "center",
            // width: 280,
            fontSize: 40,
            style: ['boldStyle'],
            margin: [0, -20, 0, 0],
          },
          {
            text: parcel.address.substring(0, 90),
            fontSize: 30,
            bold: true

          }
        ],

        defaultStyle: {
          font: "THSarabunNew",
          fontSize: 14
        },
        styles: {
          boldStyle: {
            bold: true
          }
        }
      };
      this.pdfDocGen = pdfMake.createPdf(docDefinition);
      // this.pdfDocGen.getDataUrl(data => {
      //     console.log(data);
      //     this.src = data;
      // });

      this.pdfDocGen.print();
    }
  },
  mounted() {}
};
</script>
